<script lang="ts">
    import { logs } from "@repo/core/universal";
    import type { Snippet } from "svelte";
    import ErrorMessage from "./error-message.svelte";

    const props: { children: Snippet } = $props();
</script>

<svelte:boundary
    onerror={(e: unknown) => {
        // for clickable stack trace
        console.error(e);
        logs.error(e as Error)`Client error`;
    }}
>
    {@render props.children()}
    {#snippet failed(e: unknown, reset: () => void)}
        <button onclick={reset}>reset</button>
        <ErrorMessage {e} />
    {/snippet}
</svelte:boundary>
